// Central content for Jamie M Rapavy — placeholder-friendly, edit freely.

export const BRAND = {
  name: "Jamie M Rapavy",
  tagline: "Coaching · Connecting · Clarifying",
  email: "info@devotedtodetails.com",
  location: "For wedding professionals, everywhere.",
};

export const IMAGES = {
  heroCoaching:
    "/jamie-portrait2.webp",
  heroNetworking:
    "/community-hero.jpg",
  desk:
    "https://images.unsplash.com/photo-1533090161767-e6ffed986c88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  welcome:
    "https://images.unsplash.com/photo-1752766074353-565489ca3e3c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  community:
    "/event2.webp",
  flowers:
    "https://images.unsplash.com/photo-1625036801912-fe3e180234bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  bouquet:
    "https://images.unsplash.com/photo-1561848355-890d054dc55a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  journal:
    "https://images.unsplash.com/photo-1517971129774-8a2b38fa128e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "Clarity before hustle",
    body: "You don't need to post more, do more, or add another offer. You need to see clearly where your next opportunities already live.",
  },
  {
    n: "02",
    title: "Relationships are revenue",
    body: "The professionals who grow consistently aren't the loudest marketers — they're the most intentional with their relationships and follow-up.",
  },
  {
    n: "03",
    title: "Predictable, without ads",
    body: "Steady, reliable bookings come from warm contacts, honest follow-up, and a room of people who love to refer you.",
  },
];

export const COACHING_SERVICES = [
  {
    title: "1:1 Mentorship",
    desc: "Private coaching for established wedding professionals who want more predictable revenue — without paid ads or constant hustle.",
    points: ["Revenue clarity audit", "Warm-contact relationship map", "Personalised follow-up rhythm"],
  },
  {
    title: "The Inquiry Follow-Up System",
    desc: "Everything you need to confidently move inquiries and warm leads toward a booking — with the exact language and structure.",
    points: ["Inquiry response templates", "Follow-up timing guide", "Simple lead tracker"],
  },
  {
    title: "Clarity Intensive",
    desc: "A focused session to spot missed revenue opportunities and identify five specific people to reach out to this week.",
    points: ["Clarity exercise", "Relationship audit", "Clear next steps"],
  },
];

export const NETWORKING_SERVICES = [
  {
    title: "The Connection Circle",
    desc: "A curated room of aligned wedding professionals who meet consistently, share leads generously, and celebrate each other.",
    points: ["Vetted, aligned members", "Monthly gatherings", "Warm referral loop"],
  },
  {
    title: "Referral Partnerships",
    desc: "Build trusted partnerships with pros whose work you genuinely admire and would happily recommend to every couple.",
    points: ["Partner matchmaking", "Reciprocity frameworks", "Shared client care"],
  },
  {
    title: "Community Events",
    desc: "Intimate, warm gatherings designed for real connection — not business-card collecting.",
    points: ["Small-group format", "Meaningful introductions", "Follow-up support"],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      `Thank you, Jamie M Rapavy. You guided my passion for events into the world of weddings and took me under your wing, allowing me to learn foundational wedding knowledge early on. That experience ignited my flame for serial entrepreneurship, and you taught me it was okay to be multi-passionate.`,
    name: "Tionna Van Gundy",
    role: "Wedicity Wedding Planning & Design",
    image: "/review-srquita.jpg",
  },
  {
    quote:
      `Jamie Rapavy is an incredible mentor, entrepreneur, advisor, friend, and overall person. When I entered the wedding venue business, we faced significant financial setbacks and lacked clear direction. Through Jamie's mentorship, I learned how to build meaningful, purposeful relationships within the industry, and developed programs that strengthened our brand and elevated our services. Jamie knows everyone—she is a true connector. Because she has been through it herself, her advice saved me time, energy, money, and emotional stress. Thanks to Jamie, we transformed from an Airbnb with little direction into a thriving wedding venue. I highly recommend her; it changed both my business and my life.`,
    name: "Addie Cinni",
    role: "Wedding Venue Owner",
    image: "/review-addie.jpg",
  },
  {
    quote:
      `I had a consultation with Jamie, and it was a valuable session. She was incredibly helpful, patient, and very knowledgeable—she answered all my questions and even followed up with product links and resources after our Zoom call. I highly recommend her to anyone looking to launch or elevate their mobile bar business!`,
    name: "Srquita Pegram",
    role: "The Box Mobile Event Space",
    image: "/review-tionna.jpg",
  },
];

export const COACHING = {
  primary: "#47394E",
  accent: "#A8B39B",
  buttonClass:
    "bg-[#47394E] text-[#E8DCCF] hover:bg-[#A8B39B] hover:text-[#47394E]",
};

export const NETWORKING = {
  primary: "#B7926A",
  accent: "#9C8199",
  buttonClass:
    "bg-[#B7926A] text-[#E8DCCF] hover:bg-[#9C8199] hover:text-[#47394E]",
};
